import { IconBase, type IconProps } from './IconBase';

/**
 * LotoIcon — flor de loto estilizada (5 petalos).
 *
 * Simbolo: renacimiento, comienzo, pureza.
 *
 * Composicion:
 * - Linea base horizontal (el agua / la superficie sobre la que flota).
 * - Petalo central vertical (forma de gota invertida).
 * - Dos petalos medios inclinados a 30 grados aprox.
 * - Dos petalos externos casi horizontales que dan amplitud.
 * Cada petalo es una curva quadratic Bezier cerrada para mantener
 * elegancia geometrica sin exceso de detalle.
 */
export function LotoIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      {/* Linea de agua */}
      <path d="M3.5 19h17" />
      {/* Petalo central (vertical) */}
      <path d="M12 19c0-3 -1.6-5.6 0-9 1.6 3.4 0 6 0 9Z" />
      {/* Petalo medio izquierdo */}
      <path d="M12 19c-2.2-2 -4.8-3.2 -5.6-7 3.4 0.6 5.2 3 5.6 7Z" />
      {/* Petalo medio derecho */}
      <path d="M12 19c2.2-2 4.8-3.2 5.6-7 -3.4 0.6 -5.2 3 -5.6 7Z" />
      {/* Petalo externo izquierdo */}
      <path d="M12 19c-3.6-0.4 -6.8-1.6 -8.5-4 3.4-1 6.4-0.4 8.5 4Z" />
      {/* Petalo externo derecho */}
      <path d="M12 19c3.6-0.4 6.8-1.6 8.5-4 -3.4-1 -6.4-0.4 -8.5 4Z" />
    </IconBase>
  );
}
